import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../store';
import { selectCompanyCustomization } from '../../store/entities/companyCustomization';
import { SUPPORTED_LANGUAGES } from '../../utils/i18n';
import { selectTourniquetIdentity } from '../../store/entities/tourniquetIdentity';
import { TourniquetEnter } from './TourniquetEnter';
import { TourniquetInvitation } from './TourniquetInvitation';
import { TourniquetInvitationList } from './TourniquetInvitationList';

export const TourniquetRoutes: FC = () => {
  const { i18n } = useTranslation();
  const tourniquetIdentity = useAppSelector(selectTourniquetIdentity);
  const companyCustomization = useAppSelector(selectCompanyCustomization);
  const prevInvitationsRef = useRef(tourniquetIdentity.invitations);

  useEffect(() => {
    if (prevInvitationsRef.current && !tourniquetIdentity.invitations) {
      const rawDefaultLang = companyCustomization?.defaultLanguage;
      if (rawDefaultLang) {
        const defaultLang = SUPPORTED_LANGUAGES.find((s) => s.code.toLowerCase() === rawDefaultLang.toLowerCase())?.code ?? rawDefaultLang.toLowerCase();
        i18n.changeLanguage(defaultLang);
      }
    }
    prevInvitationsRef.current = tourniquetIdentity.invitations;
  }, [tourniquetIdentity.invitations, companyCustomization?.defaultLanguage, i18n]);

  if (!tourniquetIdentity.invitations) {
    return <TourniquetEnter />;
  }

  if (!tourniquetIdentity.invitation) {
    return <TourniquetInvitationList />;
  }

  return <TourniquetInvitation />;
};
